import React, { useState, useEffect } from "react";
import CustomNavbar from "../../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarDashboard from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";
import CustomTableBackendFilters from "../../../components/CustomTableBackendFilters";

//redux
import {
  editFormType,
  saveFormType,
  getFormType,
  deleteFormType
} from "../../../redux/evaluacion_desempenio/FormType/actions"
import { FORM_TYPES } from "../utils/Constants";

//Esquema de validación
const schema = Yup.object().shape({
  nombre: Yup.string().ensure().required("**Campo requerido"),
  descripcion: Yup.string().ensure().required("**Campo requerido")
});

const FormType = (props) => {
  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);

  //Variables para filtrado y paginación
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({});

  //Variables para editar
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});

  //Variables para el formulario
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);


  //Redux
  const dispatch = useDispatch();
  const formTypeStore = useSelector(
    (store) => store.formType
  );


  const {
    loading,
    formTypes,
    formTypesLength,
    formTypeError,
    saveLoading,
    formError,
  } = formTypeStore;

  useEffect(() => {
    dispatch(getFormType({
      limit,
      offset,
      ...filters
    }));
  }, [limit, offset, filters]);

  const pages = Math.ceil(
    formTypes ? formTypesLength / limit : 0
  );

  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre",
      filterType: "text",
      filterName: "nombre__icontains"
    },

    {
      Header: "Descripción",
      accessor: "descripcion",
      filterType: "text",
      filterName: "descripcion__icontains"
    },

    {
      Header: "Fecha de creación",
      accessor: "fecha_creacion",
      filterType: "date",
      filterName: "fecha_creacion__date__icontains",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          {
            !Object.values(FORM_TYPES).includes(value.row.original.nombre) && (
              <Button
                size="sm"
                className="text-danger"
                variant="link"
                type="button"
                onClick={() => onDelete(value.row.original.id, value.row.index)}
              >
                <i className="material-icons">close</i>
              </Button>
            )
          }
        </div>
      ),
    },
  ];

  //Funciones
  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteFormType(id, data));
    }
  };


  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };



  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setOffset(0);
  };

  const _getFormTypes = (offs = offset, lim = limit) => {
    setOffset(offs);
    setLimit(lim);
  };

  const onSubmit = (req) => {

    if (!edit) {
      dispatch(saveFormType(req, setShowFormModal));
    } else {
      dispatch(editFormType(req, editItem.id, index, setShowFormModal));
    }
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              TIPO DE FORMULARIO
            </h5>
            <Form>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {!!formTypeError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {formTypeError}
            </Alert>
          )}

          <Card className="border-0">
            <Card.Body className="px-1 px-sm-2">
              <CustomTableBackendFilters
                columns={columns}
                data={formTypes || []}
                isLoadingData={loading}
                onFiltersChange={handleFiltersChange}
                filters={filters}
              />
            </Card.Body>
          </Card>
          <CustomPagint
            limit={limit}
            setLimit={setLimit}
            offset={offset}
            setOffset={setOffset}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            dataLenght={formTypesLength}
            pages={pages}
            pagFunc={_getFormTypes}
          />

        </Container>
        {/*Modal editar*/}
        <Modal show={showFormModal} onHide={() => {
          setShowFormModal(false)
          setEditItem({})
        }}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              nombre: edit ? editItem.nombre : "",
              descripcion: edit ? editItem.descripcion : "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit
                      ? "Editar Tipo de Formulario"
                      : "Crear Tipo de Formulario"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {formError &&
                    typeof formError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {formError}
                    </Alert>
                  ) : null}
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Nombre
                    </Form.Label>
                    <Form.Control
                      name="nombre"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre}
                      placeholder="Nombre"
                      onBlur={handleBlur("nombre")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.nombre && !!errors.nombre}
                      disabled= {Object.values(FORM_TYPES).includes(editItem.nombre)}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre}
                    </Form.Control.Feedback>
                    {formError &&
                      typeof formError === "object" &&
                      formError.nombre ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.nombre.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>

                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Descripción
                    </Form.Label>
                    <Form.Control
                      name="descripcion"
                      id="descripcion"
                      className="rounded"
                      as="textarea"
                      value={values.descripcion}
                      placeholder="Descripción"
                      onBlur={handleBlur("descripcion")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.descripcion && !!errors.descripcion}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.descripcion}
                    </Form.Control.Feedback>
                    {formError &&
                      typeof formError === "object" &&
                      formError.descripcion ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.descripcion.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => {
                      setShowFormModal(false)
                      setEditItem({})
                    }}
                  >
                    Cerrar
                  </Button>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoading}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoading && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default FormType;
